// src/components/Notification.js
import React from 'react';

const Notification = ({ message, type, onClose }) => {
  if (!message) return null;

  const bgColor = type === 'success' ? 'bg-green-500' : type === 'info' ? 'bg-blue-500' : 'bg-red-500';
  const textColor = 'text-white';

  return (
    <div className={`fixed top-4 left-1/2 -translate-x-1/2 px-6 py-3 rounded-lg shadow-lg z-[9999] transition-all duration-300 transform ${bgColor} ${textColor}`}>
      <div className="flex items-center justify-between">
        <p className="font-semibold">{message}</p>
        <button onClick={onClose} className="ml-4 text-white opacity-75 hover:opacity-100">
          &times;
        </button>
      </div>
    </div>
  );
};

export default Notification;
